import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const RadioButtonChecked = createSvgIcon(
  <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0Zm0 8.4a3.6 3.6 0 1 1 0 7.2 3.6 3.6 0 0 1 0-7.2Z" />,
  'RadioButtonChecked'
);

export { RadioButtonChecked };